import { createContext } from "@-/com.npmjs.use-context-selectors";
import { defaultError } from "@-/com.npmjs.react-context-default-error";
import type { useRootContextValue } from "#use-root-context-value";

export type RootContextValue = ReturnType<typeof useRootContextValue>;

export const RootContext = createContext(defaultError<RootContextValue>("RootContext"));
